var _path, _path2, _g, _path3, _path4, _g2, _g3, _g4, _g5, _g6, _g7, _path5, _g8, _path6, _g9, _path7, _path8, _path9, _path10, _g10, _g11, _g12, _path11, _path12, _path13, _g13, _path14, _path15, _path16, _path17, _path18, _path19, _g14, _path20, _g15, _path21, _g16, _path22, _g17, _path23, _path24, _path25, _g18, _path26, _g19, _path27, _path28, _path29, _g20, _path30, _g21, _path31, _path32, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeslaConnector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_668_21944)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.457 27.5H90.9008C100.008 27.5 107.397 34.9417 107.397 44.1298V92.9541C107.397 102.142 100.008 109.584 90.9008 109.584H42.457C33.35 109.584 25.9606 102.142 25.9606 92.9541V44.1298C25.9606 34.9417 33.35 27.5 42.457 27.5Z",
    fill: "#F0F2F4",
    stroke: "#30BD6F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_668_21944",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 27,
    width: 83,
    height: 84
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.457 28H90.9008C99.728 28 106.897 35.2142 106.897 44.1298V92.9541C106.897 101.87 99.728 109.084 90.9008 109.084H42.457C33.6298 109.084 26.4606 101.87 26.4606 92.9541V44.1298C26.4606 35.2142 33.6298 28 42.457 28Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_668_21944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.3604 129.523C70.1579 127.637 70.7213 125.125 72.6147 123.908C82.8396 117.351 94.0008 102.573 95.8937 84.3481C96.1248 82.1153 98.1224 80.4791 100.356 80.6926C102.589 80.9062 104.211 82.8893 103.98 85.1221C101.658 107.488 87.9788 123.669 76.971 130.733C75.0734 131.949 72.5631 131.405 71.3604 129.523Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.714 99.6166C102.295 95.1393 103.446 90.2986 103.984 85.1222C104.218 82.8874 102.593 80.9063 100.36 80.6927C98.1267 80.4792 96.1292 82.1153 95.8981 84.3482C94.9508 93.4733 91.6792 101.736 87.3651 108.534C90.0067 105.6 92.4703 102.43 96.0759 101.006C97.5775 100.414 99.2065 100.162 100.716 99.6188L100.714 99.6166Z",
    fill: "#172228"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3798 81.3598C70.6243 78.1749 64.8535 75.8549 50.1677 75.7987C16.2607 75.6621 13.2429 72.2906 13.2429 72.2906L10.8657 32.1617C10.8657 32.1617 33.5638 31.4133 54.4141 36.2922C80.7489 42.4575 91.8866 46.0864 98.4416 53.8393C102.896 59.1075 114.453 75.1813 104.924 91.1514C100.969 97.7801 82.1756 82.9142 78.383 81.3601L78.3798 81.3598Z",
    fill: "#DFEBF2",
    stroke: "#7B909B",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M108.392 77.5241C108.415 77.5306 108.437 77.5413 108.459 77.5478C108.402 74.0137 107.636 70.6442 106.517 67.5773C106.487 67.4887 106.456 67.4043 106.421 67.3196C106.377 67.1998 106.333 67.0799 106.288 66.9642C106.27 66.9154 106.252 66.8665 106.233 66.8219C106.233 66.8219 106.233 66.8219 106.233 66.8261C104.238 61.6918 101.44 58.1307 99.3564 55.5108C99.3039 55.4415 97.7976 53.8372 97.7287 53.8004C93.907 51.8115 91.1694 51.2968 87.0938 50.3005C78.3692 48.1695 70.775 46.2452 61.9455 44.771C50.7221 42.8957 38.3476 40.8244 27.882 35.68C27.8694 35.6745 27.8568 35.6689 27.8445 35.6592C27.1523 35.325 26.6659 36.6323 27.3095 37.09C30.399 39.2796 32.3303 42.3034 32.6538 46.8008C32.6812 47.1884 32.9186 47.4858 33.2224 47.4819C33.6814 47.4763 34.1379 47.4619 34.5912 47.4472C46.8246 47.0622 59.1706 46.5731 71.0667 49.4735C82.9625 52.3781 94.5465 59.0068 102.207 70.7917C103.182 72.2917 105.718 75.0337 104.668 78.5901C103.252 83.4017 98.4605 85.5519 94.6478 88.2386C94.1616 88.5836 94.2162 89.4915 94.7325 89.6712C99.0019 92.2434 102.871 92.5933 104.37 90.6471C107.378 86.7425 108.462 82.0817 108.39 77.5153L108.392 77.5241Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.338 91.1968C109.804 83.7123 109.641 76.2114 107.747 69.804C107.236 69.9627 106.737 70.2039 106.274 70.5554C103.699 72.493 102.7 76.8029 100.256 79.0187C97.1709 81.8163 93.105 80.3249 89.6608 78.8825C74.3492 72.464 58.1737 69.056 41.8409 68.8143C39.5591 68.7794 37.2837 68.5142 35.1822 67.4965C29.7147 64.8475 33.2605 52.263 33.0737 51.1923C32.8484 49.9124 31.4649 53.9018 30.6638 54.7928C29.8627 55.6839 29.4391 56.9889 28.9685 58.2037C26.1227 65.5502 20.2833 70.7038 14.1588 72.1336C13.9933 72.1728 13.8262 72.1946 13.6611 72.2295L13.6669 72.337C13.6669 72.337 16.6848 75.7085 50.5917 75.8451C65.2771 75.9055 71.0446 78.2251 78.8038 81.4062C82.5959 82.9645 101.389 97.8304 105.345 91.1975L105.338 91.1968Z",
    fill: "#183E53"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.7639 54.3119C92.2088 46.559 81.0712 42.9302 54.7363 36.7649C39.1744 33.1229 19.4393 31.5157 11.8736 31.258C14.8848 32.0157 19.6824 34.1061 22.0631 35.0362C25.5671 36.4075 28.9161 37.8789 30.7709 41.3398C31.6272 42.9392 32.7733 42.1937 34.3173 42.1209C51.2532 41.3064 73.8491 42.5656 99.2462 54.8989C99.0791 54.6898 98.9176 54.4898 98.7639 54.3119Z",
    fill: "#6396A8"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5889 75.8408C54.7722 75.8555 58.2278 76.0587 61.217 76.4079C56.3149 75.0683 51.333 74.1314 46.3115 73.5926C39.0871 72.8214 28.1118 70.5089 24.6639 72.3466C22.2889 73.6112 21.1746 73.7397 19.9816 74.1297C25.2771 74.8969 35.3923 75.7807 50.5889 75.8408Z",
    fill: "#495E6B"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0273 36.805C51.5072 36.216 50.0591 35.7894 47.5292 35.2979C49.9049 37.1384 52.9611 38.299 55.0601 41.3266C55.6283 42.1445 56.5663 42.362 57.434 42.457C69.8247 43.8028 83.1285 47.0194 98.2713 54.3705C89.6182 44.1355 68.5599 40.273 54.0302 36.8095L54.0273 36.805Z",
    fill: "#172228"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4839 50.7501C33.395 52.2381 35.5645 49.4947 37.5689 49.1042C44.768 47.7129 53.6983 50.3606 61.9533 51.4782C62.5585 51.5599 63.1768 50.749 62.1769 50.1276C58.4725 47.821 41.8203 45.6229 37.5758 44.3018C36.6834 44.0247 32.292 40.6361 32.509 43.2581C32.6508 44.9787 33.7205 46.7533 33.4839 50.7501Z",
    fill: "#B7E0ED"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2052 45.9934C35.265 45.7825 36.3526 45.8224 37.412 45.8467C40.1624 45.9454 42.8961 46.2776 45.6234 46.575C52.7394 47.3739 59.7947 48.9152 66.6279 51.3282C68.6035 52.0212 70.6657 52.804 72.6004 53.6426L73.7795 54.1536C73.8081 54.165 73.8234 54.2093 73.8131 54.2468C73.8028 54.2842 73.7676 54.3064 73.7391 54.295C72.1375 53.7205 70.5347 53.1588 68.9199 52.6515C65.7099 51.6388 62.4096 50.771 59.1414 50.0776C54.2195 49.0354 49.2359 48.248 44.2283 47.933C41.4124 47.7636 38.5867 47.8584 35.7614 47.949C35.4875 47.9516 35.1077 47.9566 34.8285 47.9459C34.6178 47.942 34.3978 47.9329 34.1916 47.9166C33.3182 47.8125 33.3136 46.2039 34.2052 45.9934Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5548 53.9992C28.4002 64.7677 20.9502 72.4167 13.264 69.7605C5.43425 67.0557 1.26866 55.8414 3.67698 44.7774C6.05378 33.8642 9.27355 30.973 20.4509 35.3286C30.787 39.3567 32.6824 43.3691 30.5548 53.9992Z",
    fill: "#1E272D"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.507 53.0445L22.13 52.7319C22.6598 52.0149 23.0051 51.0656 23.2408 50.1225C24.116 46.6341 26.3273 43.373 24.8994 40.3609C24.4306 39.3733 21.2774 37.8231 20.4393 37.3974C19.6012 36.9718 18.499 37.1784 17.9133 38.1252C17.3477 39.0354 17.3888 40.3439 17.5128 41.417C17.6092 42.2691 17.6448 43.1366 17.542 44.0032C16.8804 49.617 13.2993 50.74 11.9965 50.4434L9.65829 49.9153C7.05843 47.7103 3.44677 50.1989 3.27426 54.3132L3.10608 58.351L25.1618 66.3225L31.39 54.1892L23.5107 53.0406L23.507 53.0445Z",
    fill: "#0C1B21"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5109 42.2289C12.8902 45.1481 10.701 46.8973 8.60857 46.12C6.50673 45.3375 5.31448 42.3103 5.95355 39.3716C6.58852 36.441 8.80048 34.7282 10.8843 35.5261C12.9583 36.323 14.1307 39.3181 13.5141 42.2292L13.5109 42.2289Z",
    fill: "#1E272D"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7849 45.4256C11.1538 44.6027 10.2477 43.3705 10.1 42.5688C9.90416 41.5228 10.0564 40.3917 10.5302 39.4766C10.8038 38.9479 11.1987 38.427 11.1549 37.8067C11.0981 36.9542 10.2104 36.4637 9.48524 36.5925C8.17674 36.8171 7.34807 38.2828 6.69132 39.6116C6.57995 39.8358 6.46858 40.0599 6.35763 40.2798C6.16407 40.6668 5.97378 41.0542 5.85521 41.4829C5.83909 41.5454 5.82949 41.6086 5.81663 41.6715C5.95114 43.1348 6.5128 44.4482 7.37073 45.3035C8.50751 45.9086 10.3436 46.4124 10.7882 45.4259L10.7849 45.4256Z",
    fill: "#0D1214"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9028 48.4299C29.3264 51.3021 27.2307 53.0393 25.221 52.2917C23.2016 51.543 22.0397 48.5745 22.6378 45.683C23.2318 42.7996 25.3441 41.094 27.3447 41.8665C29.336 42.6337 30.4816 45.5664 29.9028 48.4299Z",
    fill: "#1E272D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5109 42.2285C14.0412 39.7195 13.2414 37.1549 11.6863 35.982C10.2211 36.4562 8.9565 37.9939 8.48818 40.1456C7.97759 42.4898 8.56026 44.8831 9.82101 46.2961C11.4885 46.1757 13.0121 44.5867 13.5141 42.2289L13.5109 42.2285Z",
    fill: "#B3B3B3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9848 36.23C10.4711 36.5282 9.12703 38.0366 8.65292 40.2134C8.14106 42.5703 8.80779 44.9805 10.1723 46.2456C11.6962 45.9441 13.0424 44.4145 13.508 42.224C14.0051 39.8828 13.34 37.4898 11.9852 36.2257L11.9848 36.23Z",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_668_21944",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 31,
    width: 33,
    height: 43
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7527 51.5591C35.258 41.5813 31.1408 36.9968 23.9651 34.1818C21.4071 33.1785 18.517 32.3644 15.2181 31.5482C11.2881 30.5792 6.49723 31.0684 4.07384 39.3381C4.07384 39.3381 0.0295533 51.2655 3.32298 61.7343C3.34077 61.7874 3.35856 61.8405 3.37309 61.8933C3.45111 62.1363 3.52955 62.3751 3.61409 62.6187C3.66063 62.7474 3.71044 62.8764 3.75698 63.0051C3.82173 63.1826 3.88649 63.3601 3.95819 63.5341C4.08455 63.8546 4.21785 64.1715 4.36138 64.4852C6.02954 68.197 10.1676 72.0095 13.5958 72.8515C18.2022 73.982 20.9666 72.8802 23.5211 71.0733C23.7445 70.9159 23.9668 70.737 24.1899 70.5497C28.238 67.1893 32.6675 58.7432 33.7527 51.5591ZM28.0286 42.3836C30.0198 43.1508 31.1654 46.0835 30.5866 48.9469C30.0102 51.8192 27.9145 53.5564 25.9049 52.8087C23.8854 52.06 22.7236 49.0916 23.3217 46.2001C23.9156 43.3167 26.028 41.6111 28.0286 42.3836ZM11.5677 36.0473C13.6417 36.8442 14.8141 39.8394 14.1976 42.7504C13.5769 45.6696 11.3877 47.4189 9.29525 46.6416C7.19341 45.859 6.00116 42.8319 6.64024 39.8932C7.2752 36.9626 9.48717 35.2498 11.571 36.0476L11.5677 36.0473ZM14.39 64.7146C13.4373 64.3802 12.8983 63.0049 13.1816 61.6517C13.4648 60.2984 14.4665 59.4787 15.4123 59.8167C16.358 60.1547 16.8946 61.5212 16.6151 62.8706C16.3351 64.2241 15.3395 65.0487 14.39 64.7146ZM25.6111 65.7856C25.2906 66.1557 24.8228 65.9851 24.7127 65.4352C23.6871 60.3718 19.8095 57.4535 16.1342 56.0137C14.2841 55.2862 9.28629 55.2373 5.62877 58.0207C5.26448 58.3009 4.83012 58.0267 4.70854 57.4928C3.93084 54.0451 3.83091 50.2158 4.53943 46.3815C4.74312 45.8929 4.96358 45.8977 5.14007 46.2447C6.08166 48.3786 7.68451 49.9326 9.70162 50.2747C12.4908 50.7451 15.2974 48.4928 16.4481 44.8865C17.4933 41.6118 17.3963 37.7871 15.98 35.3536C15.7408 34.9405 15.6662 34.6637 16.044 34.7441C17.4978 35.0472 19.1411 35.5659 21.0173 36.296C22.646 36.9288 24.0571 37.5612 25.268 38.2165C25.6186 38.4054 25.5844 39.112 25.2222 39.2726C23.0591 40.2632 21.2888 42.9053 20.8853 46.4577C20.4395 50.3695 21.9556 54.25 24.4975 55.7137C26.5808 56.9135 28.8029 56.3565 30.4674 54.6448C30.6102 54.535 30.7585 54.6353 30.7396 54.9242C29.7955 59.2696 27.9643 63.0519 25.6086 65.7768L25.6111 65.7856Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_668_21944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6425 35.4667L31.7895 44.3876L29.5775 66.5869L10.1489 64.6511L3.15621 56.9872L5.4808 33.6571L23.6425 35.4667Z",
    fill: "#263C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.658 59.6927L17.0356 60.1067L16.5313 65.1674L13.1256 64.8281L12.7537 64.4232L13.2588 59.354L16.658 59.6927Z",
    fill: "#263C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2394 35.6193L15.0386 37.5863L14.0326 47.6823L7.5444 47.0358L5.77212 45.0971L6.78061 34.9757L13.2394 35.6193Z",
    fill: "#263C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6684 41.9778L31.3841 43.8553L30.3929 53.803L24.1921 53.1852L22.4999 51.3357L23.4937 41.3625L29.6684 41.9778Z",
    fill: "#263C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9825 32.8912L34.8373 41.5007L31.6321 73.669L30.5974 75.2168L9.82666 73.1472L-0.968911 61.3193L2.11058 30.413L26.9825 32.8912Z",
    fill: "#263C49"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5108 42.2288C13.8662 40.5491 13.6234 38.8484 12.958 37.5503C12.8148 37.4976 12.6672 37.4572 12.5161 37.4507C11.8825 37.4218 11.2741 37.8359 10.706 38.2412C10.2587 38.5602 9.8086 38.8746 9.3613 39.1936C9.08466 39.3884 8.80349 39.5956 8.56582 39.8628C8.53979 39.9585 8.51091 40.0498 8.48773 40.1501C8.20629 41.4522 8.2596 42.7705 8.57965 43.9272C8.93698 44.4119 9.40124 44.7832 9.8908 45.033C10.3991 45.2932 10.9852 45.5013 11.5798 45.5905C12.4807 44.889 13.1982 43.7117 13.51 42.2373L13.5108 42.2288Z",
    fill: "#0D1214"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5582 51.7376C27.9271 50.9147 27.021 49.6825 26.8734 48.8808C26.6775 47.8348 26.8297 46.7038 27.3035 45.7886C27.5771 45.2599 27.972 44.739 27.9282 44.1187C27.8714 43.2662 26.9837 42.7758 26.2586 42.9045C24.9501 43.1291 24.1214 44.5948 23.4646 45.9237C23.3533 46.1478 23.2419 46.3719 23.1309 46.5918C22.9374 46.9789 22.7471 47.3662 22.6285 47.7949C22.6124 47.8575 22.6028 47.9207 22.5899 47.9835C22.7245 49.4468 23.2861 50.7602 24.144 51.6155C25.2808 52.2207 27.1169 52.7244 27.5615 51.7379L27.5582 51.7376Z",
    fill: "#0D1214"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9027 48.4298C30.4194 45.8595 29.5524 43.2411 27.9308 42.1729C26.4934 42.6327 25.2517 44.1727 24.8086 46.3355C24.3238 48.6865 24.9171 51.0723 26.1706 52.4589C27.8523 52.4596 29.4172 50.8535 29.906 48.4301L29.9027 48.4298Z",
    fill: "#B3B3B3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9027 48.4297C30.3791 46.065 29.6793 43.6558 28.2986 42.4533C26.7937 42.6968 25.4496 44.2052 24.9954 46.4139C24.5043 48.7943 25.2028 51.2162 26.5896 52.4236C28.1076 52.1814 29.4542 50.6476 29.9027 48.4297Z",
    fill: "#7C7C7C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.31 45.8314L9.3359 44.1945L10.1741 39.2137L14.4131 40.9254L13.31 45.8314Z",
    fill: "#1E272D"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9028 48.4299C30.2435 46.7317 29.9791 45.016 29.292 43.7371C29.2724 43.7352 29.2569 43.7251 29.2373 43.7231C28.5428 43.6112 27.845 43.995 27.1909 44.3703C26.6735 44.6652 26.1593 44.9604 25.6418 45.2553C25.4144 45.3866 25.189 45.5309 24.9712 45.6974C24.9109 45.9053 24.8502 46.1174 24.805 46.3395C24.4089 48.2632 24.7357 50.2118 25.5556 51.6151C25.6326 51.6698 25.7054 51.7327 25.7829 51.7831C26.1174 52.0004 26.4899 52.2 26.8793 52.3628C28.2757 51.9845 29.4845 50.5096 29.9023 48.4342L29.9028 48.4299Z",
    fill: "#0D1214"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5736 51.7652L26.0501 50.4289L26.8741 45.2319L30.5937 46.4774L29.5736 51.7652Z",
    fill: "#1E272D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6142 42.3985C11.3241 43.7552 10.3036 44.5611 9.3359 44.1945C8.36816 43.8279 7.81844 42.4291 8.10853 41.0724C8.39862 39.7157 9.42369 38.9172 10.3861 39.2833C11.3539 39.6499 11.899 41.0413 11.6089 42.398L11.6142 42.3985Z",
    fill: "url(#paint0_linear_668_21944)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6076 52.1295C34.113 42.1517 29.9958 37.5672 22.8201 34.7522C20.2621 33.7489 17.3719 32.9348 14.0731 32.1186C10.1431 31.1496 5.35218 31.6388 2.92879 39.9085C2.92879 39.9085 -0.616739 51.1329 2.67342 61.6014C2.69121 61.6545 2.70901 61.7076 2.72353 61.7603C2.80155 62.0033 2.87999 62.2421 2.96454 62.4858C3.01108 62.6144 3.06088 62.7434 3.10742 62.8721C3.17217 63.0496 3.23693 63.2271 3.30864 63.4011C3.43499 63.7216 3.5683 64.0386 3.71182 64.3523C5.37998 68.0641 9.51801 71.8765 12.9462 72.7185C17.5526 73.849 20.3171 72.7473 22.8715 70.9403C23.095 70.7829 23.3172 70.6041 23.5404 70.4167C27.5884 67.0564 31.5192 59.3133 32.6048 52.125L32.6076 52.1295ZM27.3786 42.2548C29.3698 43.0221 30.5154 45.9547 29.9366 48.8182C29.3602 51.6905 27.2645 53.4277 25.2549 52.68C23.2354 51.9313 22.0736 48.9628 22.6717 46.0713C23.2657 43.188 25.378 41.4824 27.3786 42.2548ZM10.9177 35.9186C12.9918 36.7155 14.1641 39.7107 13.5476 42.6217C12.9269 45.5409 10.7377 47.2902 8.64527 46.5128C6.54344 45.7303 5.35118 42.7032 5.99026 39.7644C6.62523 36.8339 8.83719 35.1211 10.921 35.9189L10.9177 35.9186ZM13.7401 64.5859C12.7874 64.2515 12.2483 62.8762 12.5316 61.5229C12.8148 60.1697 13.8166 59.35 14.7623 59.688C15.7081 60.026 16.2446 61.3925 15.9651 62.7418C15.6851 64.0954 14.6895 64.92 13.7401 64.5859ZM24.9611 65.6569C24.6406 66.027 24.1728 65.8564 24.0627 65.3065C23.0371 60.243 19.1595 57.3247 15.4842 55.885C13.6341 55.1575 8.63631 55.1086 4.97879 57.892C4.6145 58.1722 4.18014 57.898 4.05856 57.3641C3.28086 53.9163 3.18094 50.0871 3.88946 46.2528C4.09314 45.7642 4.3136 45.769 4.49009 46.1159C5.43168 48.2498 7.03454 49.8038 9.05164 50.146C11.8408 50.6163 14.6474 48.364 15.7982 44.7578C16.8434 41.4831 16.405 38.0051 14.9888 35.5715C14.7496 35.1585 15.0162 34.5349 15.394 34.6153C16.8478 34.9184 18.4912 35.4372 20.3674 36.1673C21.9961 36.8 23.4071 37.4325 24.6181 38.0878C24.9686 38.2767 24.9345 38.9832 24.5722 39.1439C22.4091 40.1344 20.6388 42.7766 20.2354 46.329C19.7895 50.2407 21.3057 54.1213 23.8475 55.5849C25.9308 56.7848 28.1529 56.2278 29.8174 54.516C29.9602 54.4062 30.1085 54.5066 30.0896 54.7955C29.1455 59.1409 27.3143 62.9232 24.9587 65.6481L24.9611 65.6569Z",
    fill: "#4F6B77"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59061 60.5314C8.38665 61.4862 7.67597 62.0655 7.00018 61.8314C6.32481 61.593 5.94006 60.6223 6.14403 59.6675C6.34799 58.7126 7.06193 58.1337 7.73688 58.3763C8.40898 58.6143 8.79089 59.5805 8.59019 60.5356L8.59061 60.5314Z",
    fill: "#1E272D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9654 65.2728C21.7654 66.2537 21.0527 66.8541 20.3708 66.6151C19.6889 66.3761 19.2997 65.3836 19.5001 64.3984C19.7033 63.4179 20.4161 62.8174 21.0976 63.0607C21.7758 63.3036 22.1654 64.2919 21.9654 65.2728Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_668_21944",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 58,
    width: 2,
    height: 4
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48013 59.7695C6.66375 58.9195 7.24938 58.3706 7.8502 58.4304C7.81271 58.4096 7.7789 58.3848 7.73729 58.3721C7.06234 58.1295 6.34841 58.7085 6.14444 59.6633C5.94048 60.6181 6.32196 61.5885 7.0006 61.8272C7.07401 61.8516 7.14543 61.863 7.21726 61.8702C6.61764 61.5667 6.2886 60.6657 6.48055 59.7652L6.48013 59.7695Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_668_21944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50353 58.0781L5.94764 60.5461L6.19659 58.0475L6.50353 58.0781Z",
    fill: "#263C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73921 59.5442L7.21683 61.8744L5.82906 61.7361L5.94764 60.5461L6.50353 58.0781L7.8717 58.2144L7.73921 59.5442Z",
    fill: "#263C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21683 61.8742L7.73921 59.544L7.50417 61.9028L7.21683 61.8742Z",
    fill: "#263C49"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_668_21944",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 58,
    width: 2,
    height: 4
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01976 61.8332C7.0838 61.8524 7.15153 61.8677 7.21683 61.8742C6.61721 61.5707 6.28817 60.6697 6.48012 59.7693C6.66374 58.9194 7.24937 58.3704 7.85019 58.4303C7.8127 58.4094 7.77889 58.3847 7.73728 58.372C7.71811 58.3658 7.70136 58.3684 7.68219 58.3622C7.1198 58.4131 6.60443 58.9519 6.4324 59.7517C6.2529 60.5935 6.51147 61.4404 7.01976 61.8332Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_668_21944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.76791 58.2709L6.25965 60.5255L6.48709 58.2429L6.76791 58.2709Z",
    fill: "#355E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80056 58.2742L6.2318 60.805L6.25965 60.5255L6.76791 58.2709L6.80056 58.2742Z",
    fill: "#355E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83648 58.2777L6.20395 61.0845L6.2318 60.805L6.80056 58.2742L6.83648 58.2777Z",
    fill: "#355D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86913 58.281L6.1761 61.364L6.20395 61.0845L6.83648 58.2777L6.86913 58.281Z",
    fill: "#345C6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90179 58.2842L6.14825 61.6435L6.1761 61.364L6.86913 58.281L6.90179 58.2842Z",
    fill: "#345B6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93771 58.2878L6.15561 61.7683L6.13602 61.7664L6.14825 61.6435L6.90179 58.2842L6.93771 58.2878Z",
    fill: "#335A69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97024 58.291L6.19141 61.7718L6.15549 61.7682L6.93758 58.2877L6.97024 58.291Z",
    fill: "#335968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00652 58.2949L6.22443 61.7753L6.19177 61.7721L6.9706 58.2913L7.00652 58.2949Z",
    fill: "#325867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0389 58.2978L6.26007 61.7786L6.22415 61.775L7.00625 58.2945L7.0389 58.2978Z",
    fill: "#325766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07478 58.3012L6.29268 61.7817L6.26003 61.7784L7.03886 58.2976L7.07478 58.3012Z",
    fill: "#325665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10751 58.3047L6.32867 61.7856L6.29276 61.782L7.07485 58.3015L7.10751 58.3047Z",
    fill: "#315564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14338 58.3083L6.36128 61.7888L6.32863 61.7855L7.10746 58.3047L7.14338 58.3083Z",
    fill: "#315463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17608 58.3116L6.39398 61.7921L6.36133 61.7888L7.14342 58.3083L7.17608 58.3116Z",
    fill: "#305362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21195 58.3151L6.42986 61.7956L6.39394 61.792L7.17603 58.3115L7.21195 58.3151Z",
    fill: "#305261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24462 58.3185L6.46252 61.799L6.42987 61.7958L7.21197 58.3153L7.24462 58.3185Z",
    fill: "#2F5160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28052 58.3219L6.49843 61.8024L6.46251 61.7988L7.24461 58.3183L7.28052 58.3219Z",
    fill: "#2F505F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31318 58.3253L6.53108 61.8057L6.49843 61.8025L7.28052 58.322L7.31318 58.3253Z",
    fill: "#2F4F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34911 58.3289L6.56702 61.8094L6.5311 61.8058L7.31319 58.3253L7.34911 58.3289Z",
    fill: "#2E4E5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3818 58.3321L6.5997 61.8126L6.56705 61.8093L7.34914 58.3288L7.3818 58.3321Z",
    fill: "#2E4D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41769 58.3357L6.63559 61.8162L6.59967 61.8126L7.38177 58.3321L7.41769 58.3357Z",
    fill: "#2D4D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45028 58.3388L6.66818 61.8193L6.63553 61.816L7.41763 58.3355L7.45028 58.3388Z",
    fill: "#2D4C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48627 58.3427L6.70418 61.8232L6.66826 61.8196L7.45036 58.3391L7.48627 58.3427Z",
    fill: "#2C4B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51893 58.3459L6.73683 61.8264L6.70418 61.8231L7.48627 58.3426L7.51893 58.3459Z",
    fill: "#2C4A57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55485 58.3493L6.77275 61.8297L6.73683 61.8262L7.51893 58.3457L7.55485 58.3493Z",
    fill: "#2C4956"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58747 58.3525L6.80537 61.833L6.77272 61.8297L7.55482 58.3492L7.58747 58.3525Z",
    fill: "#2B4855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62342 58.3562L6.84132 61.8367L6.80541 61.8331L7.5875 58.3526L7.62342 58.3562Z",
    fill: "#2B4754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65606 58.3596L6.87396 61.84L6.84131 61.8368L7.62341 58.3563L7.65606 58.3596Z",
    fill: "#2A4653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69202 58.3631L6.90993 61.8435L6.87401 61.84L7.6561 58.3595L7.69202 58.3631Z",
    fill: "#2A4552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7246 58.366L6.9425 61.8465L6.90985 61.8433L7.69195 58.3628L7.7246 58.366Z",
    fill: "#294451"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75729 58.3696L6.97845 61.8504L6.94254 61.8468L7.72463 58.3663L7.75729 58.3696Z",
    fill: "#294350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79325 58.3732L7.01115 61.8537L6.9785 61.8505L7.75733 58.3696L7.79325 58.3732Z",
    fill: "#29424F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82584 58.3765L7.04701 61.8573L7.01109 61.8538L7.79319 58.3733L7.82584 58.3765Z",
    fill: "#28414E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85106 58.4216L7.07971 61.8604L7.04706 61.8572L7.82589 58.3764L7.85528 58.3793L7.85106 58.4216Z",
    fill: "#28404D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82314 58.7011L7.11556 61.8639L7.07964 61.8604L7.85099 58.4216L7.82314 58.7011Z",
    fill: "#273F4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79532 58.9806L7.14825 61.8672L7.1156 61.8639L7.82317 58.7011L7.79532 58.9806Z",
    fill: "#273E4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76707 59.2645L7.18419 61.871L7.14827 61.8674L7.79534 58.9808L7.76707 59.2645Z",
    fill: "#263D4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73919 59.5437L7.21681 61.8739L7.18415 61.8706L7.76704 59.2642L7.73919 59.5437Z",
    fill: "#263C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21684 61.8743L7.73922 59.5441L7.50419 61.903L7.21684 61.8743Z",
    fill: "#263C49"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_668_21944",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 63,
    width: 3,
    height: 4
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8358 64.5048C20.0154 63.6288 20.606 63.0632 21.2133 63.1237C21.1758 63.1028 21.1387 63.0778 21.1004 63.0654C20.4189 62.8221 19.7029 63.4223 19.5029 64.4032C19.2993 65.3879 19.6917 66.3808 20.3736 66.6198C20.447 66.6443 20.5184 66.6556 20.5903 66.6628C19.9845 66.3544 19.6478 65.4312 19.8386 64.5093L19.8358 64.5048Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_668_21944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8672 62.7672L19.3149 65.2313L19.5635 62.7369L19.8672 62.7672Z",
    fill: "#263C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0788 64.4747L20.5875 66.6583L19.1867 66.5187L19.3149 65.2313L19.8672 62.7672L21.2353 62.9035L21.0788 64.4747Z",
    fill: "#263C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5875 66.6581L21.0788 64.4745L20.8585 66.6851L20.5875 66.6581Z",
    fill: "#263C49"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_668_21944",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 63,
    width: 3,
    height: 4
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5874 66.6579C19.9817 66.3494 19.6449 65.4263 19.8357 64.5044C20.0153 63.6284 20.6059 63.0628 21.2133 63.1233C21.1758 63.1025 21.1387 63.0774 21.1004 63.065C21.0241 63.036 20.9494 63.0243 20.8743 63.0168C20.3785 63.1941 19.9521 63.7333 19.7982 64.4835C19.6377 65.2673 19.8201 66.0511 20.2142 66.5309C20.2672 66.5618 20.3202 66.5927 20.3773 66.6155C20.4507 66.64 20.5221 66.6514 20.5939 66.6585L20.5874 66.6579Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_668_21944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1397 62.9444L19.6463 65.1492L19.8687 62.9174L20.1397 62.9444Z",
    fill: "#355E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1756 62.9479L19.618 65.4329L19.6463 65.1492L20.1397 62.9444L20.1756 62.9479Z",
    fill: "#355E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2082 62.9512L19.5897 65.7166L19.618 65.4329L20.1756 62.9479L20.2082 62.9512Z",
    fill: "#355D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2442 62.9548L19.5615 66.0004L19.5897 65.7166L20.2082 62.9512L20.2442 62.9548Z",
    fill: "#345C6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2801 62.9584L19.5328 66.2883L19.5615 66.0004L20.2442 62.9548L20.2801 62.9584Z",
    fill: "#345B6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3127 62.9616L19.5066 66.5509L19.5328 66.2883L20.2801 62.9584L20.3127 62.9616Z",
    fill: "#335A69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3487 62.9652L19.5425 66.5545L19.5066 66.5509L20.3127 62.9616L20.3487 62.9652Z",
    fill: "#335968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3847 62.9684L19.5786 66.5577L19.5427 66.5541L20.3488 62.9648L20.3847 62.9684Z",
    fill: "#325867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4172 62.9717L19.6111 66.561L19.5784 66.5577L20.3846 62.9684L20.4172 62.9717Z",
    fill: "#325766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4532 62.975L19.647 66.5642L19.6111 66.5607L20.4173 62.9714L20.4532 62.975Z",
    fill: "#325665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4891 62.9789L19.683 66.5682L19.6471 66.5646L20.4532 62.9753L20.4891 62.9789Z",
    fill: "#315564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5218 62.9821L19.7157 66.5714L19.683 66.5681L20.4892 62.9788L20.5218 62.9821Z",
    fill: "#315463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5577 62.9854L19.7515 66.5747L19.7156 66.5712L20.5218 62.9819L20.5577 62.9854Z",
    fill: "#305362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5936 62.9891L19.7875 66.5784L19.7515 66.5748L20.5577 62.9855L20.5936 62.9891Z",
    fill: "#305261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6262 62.9923L19.8201 66.5816L19.7875 66.5784L20.5936 62.9891L20.6262 62.9923Z",
    fill: "#2F5160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6622 62.9959L19.856 66.5852L19.8201 66.5817L20.6262 62.9924L20.6622 62.9959Z",
    fill: "#2F505F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6981 62.9997L19.892 66.589L19.8561 66.5854L20.6622 62.9962L20.6981 62.9997Z",
    fill: "#2F4F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7307 63.0028L19.9246 66.5921L19.892 66.5889L20.6981 62.9996L20.7307 63.0028Z",
    fill: "#2E4E5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7667 63.0063L19.9605 66.5956L19.9246 66.592L20.7307 63.0027L20.7667 63.0063Z",
    fill: "#2E4D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8025 63.0101L19.9964 66.5994L19.9605 66.5958L20.7666 63.0065L20.8025 63.0101Z",
    fill: "#2D4D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8352 63.0133L20.0291 66.6026L19.9964 66.5994L20.8026 63.0101L20.8352 63.0133Z",
    fill: "#2D4C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8711 63.0169L20.065 66.6062L20.0291 66.6027L20.8352 63.0134L20.8711 63.0169Z",
    fill: "#2C4B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9071 63.0201L20.1009 66.6094L20.065 66.6058L20.8711 63.0165L20.9071 63.0201Z",
    fill: "#2C4A57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9397 63.0238L20.1336 66.6131L20.1009 66.6099L20.907 63.0206L20.9397 63.0238Z",
    fill: "#2C4956"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9757 63.0272L20.1695 66.6165L20.1336 66.6129L20.9398 63.0236L20.9757 63.0272Z",
    fill: "#2B4855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0116 63.0309L20.2055 66.6202L20.1695 66.6166L20.9757 63.0273L21.0116 63.0309Z",
    fill: "#2B4754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0442 63.0342L20.2381 66.6235L20.2054 66.6202L21.0116 63.0309L21.0442 63.0342Z",
    fill: "#2A4653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0801 63.0376L20.2739 66.6269L20.238 66.6233L21.0442 63.034L21.0801 63.0376Z",
    fill: "#2A4552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.116 63.0412L20.3099 66.6305L20.274 66.627L21.0801 63.0377L21.116 63.0412Z",
    fill: "#294451"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1487 63.0446L20.3426 66.6339L20.3099 66.6306L21.1161 63.0413L21.1487 63.0446Z",
    fill: "#294350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1846 63.0481L20.3785 66.6374L20.3425 66.6338L21.1487 63.0445L21.1846 63.0481Z",
    fill: "#29424F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2205 63.0515L20.4144 66.6408L20.3785 66.6372L21.1846 63.0479L21.2205 63.0515Z",
    fill: "#28414E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1923 63.3354L20.4471 66.6442L20.4144 66.641L21.2206 63.0517L21.1923 63.3354Z",
    fill: "#28404D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.164 63.6192L20.483 66.6478L20.4471 66.6442L21.1923 63.3354L21.164 63.6192Z",
    fill: "#273F4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1358 63.9028L20.5189 66.6513L20.483 66.6477L21.164 63.6191L21.1358 63.9028Z",
    fill: "#273E4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.107 64.191L20.5516 66.6547L20.5189 66.6515L21.1357 63.903L21.107 64.191Z",
    fill: "#263D4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0787 64.4745L20.5874 66.6581L20.5515 66.6545L21.107 64.1907L21.0787 64.4745Z",
    fill: "#263C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5874 66.6581L21.0787 64.4745L20.8585 66.6851L20.5874 66.6581Z",
    fill: "#263C49"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9284 62.3489C15.6484 63.7025 14.6528 64.5271 13.7033 64.193C12.7506 63.8585 12.2116 62.4833 12.4949 61.13C12.7781 59.7768 13.7798 58.9571 14.7256 59.2951C15.6713 59.6331 16.2079 60.9996 15.9284 62.3489Z",
    fill: "#1E272D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9284 62.3489C15.6484 63.7025 14.6528 64.5271 13.7033 64.193C12.7506 63.8585 12.2116 62.4833 12.4949 61.13C12.7781 59.7768 13.7798 58.9571 14.7256 59.2951C15.6713 59.6331 16.2079 60.9996 15.9284 62.3489Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_668_21944",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 59,
    width: 4,
    height: 6
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0644 64.1434C13.1758 63.8282 12.6671 62.5457 12.9354 61.2766C13.2036 60.0074 14.1374 59.2408 15.0224 59.5599C15.1435 59.6019 15.2589 59.669 15.3631 59.7478C15.1792 59.5413 14.9674 59.3833 14.7219 59.299C13.7762 58.961 12.7744 59.7807 12.4912 61.1339C12.2075 62.4914 12.747 63.8624 13.6997 64.1969C13.9705 64.2923 14.2449 64.2854 14.5068 64.2046C14.3611 64.2115 14.2109 64.1965 14.064 64.1476L14.0644 64.1434Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_668_21944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9995 58.8794L12.224 62.3264L12.5717 58.8368L12.9995 58.8794Z",
    fill: "#263C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2538 60.879L14.477 64.3386L12.0476 64.0965L12.224 62.3264L12.9995 58.8794L15.4289 59.1215L15.2538 60.879Z",
    fill: "#263C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.477 64.3384L15.2537 60.8788L14.9048 64.3811L14.477 64.3384Z",
    fill: "#263C49"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_668_21944",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 59,
    width: 4,
    height: 6
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0644 64.1433C13.1758 63.8281 12.6671 62.5456 12.9354 61.2765C13.2036 60.0073 14.1374 59.2406 15.0224 59.5598C15.1435 59.6018 15.2588 59.6689 15.3631 59.7477C15.1792 59.5412 14.9674 59.3832 14.7219 59.2989C14.6359 59.2689 14.5514 59.2562 14.4669 59.2435C13.7205 59.3873 13.0545 60.1464 12.8273 61.2358C12.588 62.3795 12.9089 63.5278 13.5582 64.1271C13.6055 64.1489 13.6515 64.1834 13.7025 64.2013C13.9733 64.2968 14.2477 64.2899 14.5097 64.2091C14.3639 64.2159 14.2137 64.2009 14.0669 64.1521L14.0644 64.1433Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_668_21944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3016 59.1237L12.6019 62.2403L12.9163 59.0853L13.3016 59.1237Z",
    fill: "#355E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3669 59.1302L12.5496 62.7655L12.6019 62.2403L13.3016 59.1237L13.3669 59.1302Z",
    fill: "#355E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4289 59.1364L12.4977 63.2863L12.5496 62.7655L13.3669 59.1302L13.4289 59.1364Z",
    fill: "#355D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4943 59.1429L12.4458 63.8072L12.4977 63.2863L13.4289 59.1364L13.4943 59.1429Z",
    fill: "#345C6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5563 59.1491L12.4362 64.1356L12.4133 64.1333L12.4458 63.8072L13.4943 59.1429L13.5563 59.1491Z",
    fill: "#345B6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6213 59.1553L12.5011 64.1418L12.4358 64.1353L13.556 59.1488L13.6213 59.1553Z",
    fill: "#335A69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6837 59.1612L12.5635 64.1477L12.5015 64.1415L13.6216 59.155L13.6837 59.1612Z",
    fill: "#335968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7489 59.1677L12.6288 64.1542L12.5635 64.1477L13.6836 59.1612L13.7489 59.1677Z",
    fill: "#325867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.811 59.174L12.6909 64.1605L12.6289 64.1543L13.749 59.1678L13.811 59.174Z",
    fill: "#325766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8763 59.1803L12.7561 64.1668L12.6908 64.1603L13.811 59.1738L13.8763 59.1803Z",
    fill: "#325665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9383 59.1863L12.8182 64.1728L12.7561 64.1667L13.8763 59.1801L13.9383 59.1863Z",
    fill: "#315564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0036 59.193L12.8835 64.1795L12.8182 64.173L13.9383 59.1865L14.0036 59.193Z",
    fill: "#315463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0657 59.1993L12.9456 64.1858L12.8835 64.1796L14.0037 59.1931L14.0657 59.1993Z",
    fill: "#305362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.131 59.2058L13.0108 64.1923L12.9455 64.1858L14.0657 59.1993L14.131 59.2058Z",
    fill: "#305261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.193 59.2117L13.0729 64.1982L13.0108 64.192L14.1309 59.2055L14.193 59.2117Z",
    fill: "#2F5160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2583 59.2184L13.1382 64.2049L13.0729 64.1984L14.193 59.2119L14.2583 59.2184Z",
    fill: "#2F505F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3204 59.2245L13.2002 64.211L13.1382 64.2049L14.2583 59.2184L14.3204 59.2245Z",
    fill: "#2F4F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3857 59.2311L13.2655 64.2176L13.2002 64.2111L14.3204 59.2246L14.3857 59.2311Z",
    fill: "#2E4E5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4477 59.2374L13.3309 64.2242L13.2656 64.2177L14.3857 59.2312L14.4477 59.2374Z",
    fill: "#2E4D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.513 59.2438L13.3929 64.2303L13.3309 64.2241L14.4477 59.2373L14.513 59.2438Z",
    fill: "#2D4D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5751 59.25L13.4582 64.2369L13.3929 64.2304L14.513 59.2439L14.5751 59.25Z",
    fill: "#2D4C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6404 59.2566L13.5203 64.2431L13.4583 64.237L14.5751 59.2501L14.6404 59.2566Z",
    fill: "#2C4B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7024 59.2627L13.5856 64.2496L13.5203 64.2431L14.6404 59.2566L14.7024 59.2627Z",
    fill: "#2C4A57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7677 59.2693L13.6476 64.2558L13.5856 64.2497L14.7024 59.2628L14.7677 59.2693Z",
    fill: "#2C4956"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.833 59.2758L13.7129 64.2623L13.6476 64.2558L14.7677 59.2693L14.833 59.2758Z",
    fill: "#2B4855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8951 59.2818L13.7749 64.2683L13.7129 64.2621L14.833 59.2756L14.8951 59.2818Z",
    fill: "#2B4754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9604 59.2885L13.8403 64.275L13.775 64.2685L14.8951 59.282L14.9604 59.2885Z",
    fill: "#2A4653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0224 59.2946L13.9023 64.2811L13.8403 64.2749L14.9604 59.2884L15.0224 59.2946Z",
    fill: "#2A4552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0878 59.3013L13.9676 64.2878L13.9023 64.2813L15.0224 59.2948L15.0878 59.3013Z",
    fill: "#294451"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1497 59.3072L14.0296 64.2937L13.9675 64.2875L15.0877 59.301L15.1497 59.3072Z",
    fill: "#294350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2151 59.3137L14.0949 64.3002L14.0296 64.2937L15.1498 59.3072L15.2151 59.3137Z",
    fill: "#29424F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2771 59.3201L14.157 64.3066L14.095 64.3004L15.2151 59.3139L15.2771 59.3201Z",
    fill: "#28414E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3424 59.3263L14.2223 64.3128L14.157 64.3063L15.2771 59.3198L15.3424 59.3263Z",
    fill: "#28404D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4045 59.3326L14.2844 64.3191L14.2223 64.3129L15.3425 59.3264L15.4045 59.3326Z",
    fill: "#273F4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3576 59.837L14.3497 64.3257L14.2844 64.3192L15.4045 59.3327L15.4078 59.3331L15.3576 59.837Z",
    fill: "#273E4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3055 60.3578L14.4116 64.3318L14.3496 64.3257L15.3574 59.8369L15.3055 60.3578Z",
    fill: "#263D4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2537 60.8786L14.477 64.3383L14.4117 64.3317L15.3056 60.3577L15.2537 60.8786Z",
    fill: "#263C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.477 64.3383L15.2537 60.8787L14.9047 64.3809L14.477 64.3383Z",
    fill: "#263C49"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9283 62.3489C16.1573 61.2426 15.8326 60.1325 15.1917 59.5811C14.56 59.8645 14.0249 60.5682 13.8234 61.5319C13.6094 62.5541 13.8241 63.5763 14.3119 64.2408C15.0447 64.1342 15.7106 63.4093 15.932 62.345L15.9283 62.3489Z",
    fill: "#B3B3B3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3522 59.7252C14.6966 59.9165 14.1236 60.6036 13.9212 61.5757C13.7077 62.5937 13.9587 63.6153 14.4966 64.2078C15.1554 64.0168 15.7292 63.3212 15.9284 62.3488C16.1382 61.3347 15.8904 60.3135 15.3522 59.7252Z",
    fill: "#7C7C7C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9285 63.0505L15.7042 63.2755C15.7936 63.0399 15.8544 62.8269 15.9049 62.5517C15.9742 62.1867 15.9969 61.8273 15.9858 61.4747L15.2115 61.2039L14.9253 63.0502L14.9285 63.0505Z",
    fill: "#1E272D"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2123 69.403L10.8835 67.9024C10.5838 67.7999 10.4124 67.3679 10.5016 66.9363C10.5904 66.5089 10.9101 66.2456 11.2094 66.3524L15.5342 67.8611C15.8307 67.9634 15.9987 68.395 15.9104 68.8182C15.8216 69.2456 15.5088 69.5052 15.2123 69.403Z",
    fill: "white"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2295 69.2636L10.9138 67.7644C10.665 67.6797 10.5257 67.3237 10.6007 66.9676C10.6753 66.6158 10.9345 66.3978 11.1833 66.4825L15.4953 67.9857C15.7409 68.07 15.8802 68.426 15.8055 68.7779C15.7342 69.13 15.4755 69.3438 15.2299 69.2594L15.2295 69.2636Z",
    fill: "#1E272D"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5508 67.4944C11.302 67.4097 11.1627 67.0537 11.2378 66.6976C11.2506 66.6347 11.2757 66.5816 11.3008 66.5285L11.1797 66.4865C10.9309 66.4019 10.6721 66.6156 10.5971 66.9717C10.5225 67.3235 10.6618 67.6795 10.9101 67.7684L15.2259 69.2677C15.4265 69.339 15.632 69.1969 15.7389 68.951L11.5471 67.4983L11.5508 67.4944Z",
    fill: "#172228"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5919 62.2887C15.4713 62.8664 15.0448 63.2152 14.6444 63.076C14.2402 62.9306 14.0102 62.3471 14.1308 61.7693C14.2514 61.1916 14.6778 60.8428 15.0821 60.9882C15.4863 61.1336 15.7164 61.7171 15.5963 62.2891L15.5919 62.2887Z",
    fill: "url(#paint1_linear_668_21944)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6647 47.1515C24.3758 48.5712 24.9397 50.0243 25.9289 50.3949C26.9181 50.7655 27.9491 49.9198 28.2379 48.5001C28.5261 47.0877 27.9622 45.6346 26.973 45.2639C25.9845 44.8861 24.9535 45.7318 24.6647 47.1515Z",
    fill: "url(#paint2_linear_668_21944)"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.098 31.4287C15.5118 32.1422 19.8745 33.2697 24.0817 34.9977C25.6408 35.7005 27.2886 36.241 28.6845 37.3895C30.9879 39.3597 32.4686 42.7021 32.8082 46.2773C32.2497 42.0858 30.1699 38.2689 27.0951 36.7264C26.069 36.235 25.026 35.7804 23.9765 35.3593C19.7872 33.616 15.4529 32.4357 11.0947 31.4283L11.098 31.4287Z",
    fill: "#010202"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2241 41.8203C31.8586 43.099 30.9493 53.35 25.8393 52.7724C24.378 52.6439 23.4711 51.0224 23.0301 49.3918C23.5756 50.9003 24.4624 52.4257 25.8721 52.4763C30.6864 52.8448 31.4263 43.3339 27.2241 41.8203Z",
    fill: "#0B2F38"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.881 35.5258C14.718 36.7336 14.9136 44.0709 11.2563 46.2556C9.19518 47.5471 6.75334 45.9737 6.07295 43.3697C7.24386 46.8095 10.8977 47.5713 12.7266 44.2422C14.4797 41.2434 13.6101 36.6659 10.881 35.5258Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1277 65.1846C24.0826 65.1074 24.0449 65.0224 24.0261 64.9136C23.0004 59.8501 19.1229 56.9318 15.4476 55.4921C13.5975 54.7646 8.59966 54.7157 4.94214 57.4991C4.89958 57.529 4.85744 57.5548 4.81288 57.5717C4.82468 57.5857 4.83279 57.6036 4.84132 57.6173C5.29101 58.201 6.0236 58.2954 6.6689 58.1074C7.31421 57.9193 7.91047 57.4954 8.51956 57.1413C11.0394 55.6816 13.928 55.4519 16.4679 56.5047C19.0041 57.5615 21.1663 59.8898 22.4088 62.909C22.7993 63.8547 23.2142 64.9866 24.0441 65.1634C24.0734 65.1663 24.0996 65.1689 24.1257 65.1715L24.1277 65.1846Z",
    fill: "#B3B3B3"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4623 55.9309C19.5637 57.2065 22.5777 59.8549 23.752 63.8896C23.533 63.4401 23.37 62.9576 23.1141 62.5472C21.496 59.5247 19.0144 57.4897 16.4623 55.9309Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.19971 47.4996C6.79033 49.1764 8.82234 50.5935 10.9984 50.1346C13.1849 49.8691 15.1689 48.1935 16.1865 45.6261C15.9761 46.2809 15.6993 46.9077 15.3643 47.4902C14.3455 49.2748 12.6712 50.2585 11.0237 50.5092C8.78363 50.9489 6.66494 49.4419 5.20298 47.4999L5.19971 47.4996Z",
    fill: "#0B2F38"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3223 41.2664C33.2001 43.6348 33.3583 47.3757 33.1541 50.8154C32.8833 54.3939 31.7144 57.652 30.4343 60.7364C29.0441 63.7329 27.5877 67.0307 25.2988 69.0523C23.082 71.0127 20.4769 72.6991 17.7997 72.6932C20.5853 72.0085 22.9649 69.9703 25.1795 67.7017C26.9564 65.5564 28.2054 62.7512 29.4076 60.0524C32.0339 54.181 33.801 47.2359 30.7704 41.344L31.3251 41.271L31.3223 41.2664Z",
    fill: "#172228"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0143 35.7515C6.18651 36.7686 5.93235 42.3974 8.14476 45.4791C8.29757 45.6996 8.45648 45.9251 8.67397 46.0921C8.4195 45.9984 8.20085 45.8098 7.99896 45.6186C6.57198 44.219 5.83043 42.0964 6.02948 40.1318C6.24468 37.972 7.731 35.5325 10.0139 35.7557L10.0143 35.7515Z",
    fill: "#172228"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0097 42.0927C24.4949 42.964 23.2959 44.705 23.1779 46.8488C23.0675 48.9164 23.4324 51.1126 24.7386 52.3676C23.9439 52.0361 23.3335 51.1455 22.9893 50.1318C21.8614 46.8887 23.0231 42.6762 26.0101 42.0885L26.0097 42.0927Z",
    fill: "#172228"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2177 34.8097C52.041 36.9412 56.1626 41.415 58.6871 47.0897C59.1104 48.1369 59.5046 49.0786 59.6309 50.3273C59.7019 52.9903 58.2369 53.9906 61.065 54.5675C66.8152 55.7691 72.9917 56.8636 78.6481 58.5435C85.7726 60.9128 94.7709 62.977 98.4575 72.0479C98.8335 73.0733 99.1026 74.2121 99.0851 75.4464C98.8947 77.7883 97.9409 79.9473 96.8039 81.7928C94.4483 85.3774 90.6859 86.8972 87.2629 86.5989C90.5943 86.5588 94.2163 84.8924 96.3339 81.314C97.3127 79.6323 98.125 77.5363 98.2705 75.4808C98.2449 73.421 97.3217 71.5327 96.3181 70.0213C94.1513 66.8458 91.1851 64.8095 88.0463 63.4788C84.8886 62.0736 81.6295 60.9576 78.3322 60.026C75.0362 59.0817 71.7112 58.2628 68.3676 57.5319L63.3463 56.4286C62.0563 56.1033 60.7599 55.9741 59.5113 55.3664C57.5464 54.2682 58.7502 52.348 58.766 50.4678C58.705 49.525 58.3041 48.4843 57.9823 47.6097C55.6778 41.944 51.7967 37.3403 47.2173 34.8139L47.2177 34.8097Z",
    fill: "#72A1BB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_668_21944",
    x1: 8.03884,
    y1: 41.5573,
    x2: 11.6832,
    y2: 41.9205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_668_21944",
    x1: 14.099,
    y1: 61.953,
    x2: 15.6192,
    y2: 62.1045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_668_21944",
    x1: 24.5985,
    y1: 47.6449,
    x2: 28.3034,
    y2: 48.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_668_21944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeslaConnector);
export default __webpack_public_path__ + "static/media/tesla_connector.79b27516fa91b094a4ebd3df417bd6e0.svg";
export { ForwardRef as ReactComponent };